export default "__VITE_ASSET__4902e7aa__"